/* eslint-disable import/prefer-default-export */
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { GatsbyImage } from 'gatsby-plugin-image'
import ImageCut from '../../../assets/images/graphic_imageCut.svg'

// Style Tokens
//---------------------------------
// None

// Styled Component Declarations
//---------------------------------

// 1:! Image
//---------------------------------
const ImageWrapperSquare = styled.div`
  aspect-ratio: 1/1;
  overflow: hidden;
  position: relative;
  display: block;
`

const ImageWrapperRectangle = styled.div`
  aspect-ratio: 4/3;
  overflow: hidden;
  position: relative;
  display: block;
`

const ImageWrapperWide = styled.div`
  aspect-ratio: 16/9;
  overflow: hidden;
  position: relative;
  display: block;
`

const ImageWrapper = styled.div`
  overflow: hidden;
  position: relative;
`

const SquareClippedFrame = styled(ImageWrapperSquare)`
  border-radius: 4px;

  img {
    height: -webkit-fill-available;
    width: auto;
  }

  &:before {
    background-image: url(${ImageCut});
    background-position: top left;
    background-size: cover;
    content: '';
    height: 30px;
    left: -1px;
    position: absolute;
    top: -1px;
    transform: rotate(180deg);
    width: 30px;
    z-index: 1;
  }

  &:after {
    background-image: url(${ImageCut});
    background-position: bottom right;
    background-size: cover;
    bottom: -1px;
    content: '';
    height: 30px;
    position: absolute;
    right: -1px;
    width: 30px;
    z-index: 1;
  }

  @media only screen and (min-width: 62em) {
    &:before {
      content: '';
      height: 60px;
      width: 60px;
    }

    &:after {
      content: '';
      height: 60px;
      width: 60px;
    }
  }
`

const SquareLeftClippedFrame = styled(ImageWrapperSquare)`
  border-radius: 4px;
  &:before {
    background-image: url(${ImageCut});
    background-position: top left;
    background-size: cover;
    content: '';
    height: 30px;
    left: -1px;
    position: absolute;
    top: -1px;
    transform: rotate(180deg);
    width: 30px;
    z-index: 1;
  }

  @media only screen and (min-width: 62em) {
    &:before {
      content: '';
      height: 60px;
      width: 60px;
    }

    //&:after {
    //  content: '';
    //  height: 60px;
    //  width: 60px;
    //}
  }
`

const RectangleClippedFrame = styled(ImageWrapperRectangle)`
  border-radius: 4px;

  &:before {
    background-image: url(${ImageCut});
    background-position: top left;
    background-size: cover;
    content: '';
    height: 30px;
    left: -1px;
    position: absolute;
    top: -1px;
    transform: rotate(180deg);
    width: 30px;
    z-index: 1;
  }

  &:after {
    background-image: url(${ImageCut});
    background-position: bottom right;
    background-size: cover;
    bottom: -1px;
    content: '';
    height: 30px;
    position: absolute;
    right: -1px;
    width: 30px;
    z-index: 1;
  }

  @media only screen and (min-width: 62em) {
    &:before {
      content: '';
      height: 60px;
      width: 60px;
    }

    &:after {
      content: '';
      height: 60px;
      width: 60px;
    }
  }
`

const RectangleLeftClippedFrame = styled(ImageWrapperRectangle)`
  border-radius: 4px;
  &:after {
    background-image: url(${ImageCut});
    background-position: bottom right;
    background-size: cover;
    top: -1px;
    content: '';
    height: 30px;
    position: absolute;
    transform: rotate(-180deg);
    left: -1px;
    width: 30px;
    z-index: 1;
  }

  @media only screen and (min-width: 62em) {
    @media only screen and (min-width: 62em) {
      &:after {
        content: '';
        height: 60px;
        width: 60px;
      }
    }
  }
`

const RectangleRightClippedFrame = styled(ImageWrapperRectangle)`
  &:after {
    background-image: url(${ImageCut});
    background-position: bottom right;
    background-size: cover;
    top: -1px;
    content: '';
    height: 30px;
    position: absolute;
    transform: rotate(-90deg);
    right: -1px;
    width: 30px;
    z-index: 1;
  }
`

const RectangleRightClippedFrame16x9 = styled(RectangleRightClippedFrame)`
  aspect-ratio: 16/9;
`

const RectangleRightClippedFrame1x1 = styled(RectangleRightClippedFrame)`
  aspect-ratio: 1/1;
`

const WideClippedFrame = styled(ImageWrapperWide)`
  border-radius: 4px;
  &:before {
    content: '';
    background-image: url(${ImageCut});
    background-position: top left;
    background-size: cover;
    height: 30px;
    left: -1px;
    position: absolute;
    top: -1px;
    transform: rotate(180deg);
    width: 30px;
    z-index: 1;
  }

  @media only screen and (min-width: 64em) {
    &:before {
      content: '';
      height: 60px;
      width: 60px;
    }
  }

  @media only screen and (min-width: 90em) {
    &.cut-size-lg:before {
      content: '';
      height: 30px;
      width: 30px;
    }
  }
`

const LeftClippedNoAspect = styled(ImageWrapper)`
  border-radius: 4px;
  &:before {
    content: '';
    background-image: url(${ImageCut});
    background-position: top left;
    background-size: cover;
    height: 30px;
    left: -1px;
    position: absolute;
    top: -1px;
    transform: rotate(180deg);
    width: 30px;
    z-index: 1;
  }

  @media only screen and (min-width: 62em) {
    &:before {
      content: '';
      height: 60px;
      width: 60px;
    }
  }
`

const ImageElement = styled.img`
  filter: ${({ isLoading }) => (isLoading ? '10px' : '0')};
`

// Component Export
//---------------------------------
export default function Image({
  url,
  imgSrc,
  altTag = '',
  title,
  aspectRatio,
  hasFrame,
  loading,
  cutSize,
  className,
  fit = 'cover',
}) {
  const [isLoading, setIsLoading] = useState(true)

  return (
    <>
      {aspectRatio === '1/1' && url && hasFrame === 'No Frame' && (
        <ImageWrapperSquare>
          <ImageElement
            src={url}
            className={className}
            alt={altTag}
            loading="lazy"
            fit={fit}
            isLoading={isLoading}
            onLoad={() => setIsLoading(false)}
          />
          {/* <ImageElement src={imgSrc} alt={altTag} /> */}
        </ImageWrapperSquare>
      )}
      {aspectRatio === '1/1' && imgSrc && hasFrame === 'No Frame' && (
        <ImageWrapperSquare>
          <GatsbyImage image={imgSrc} alt={altTag} />
          {/* <ImageElement src={imgSrc} alt={altTag} /> */}
        </ImageWrapperSquare>
      )}
      {aspectRatio === '1/1' && url && hasFrame === 'Bottom Top Clip' && (
        <SquareClippedFrame>
          <ImageElement
            className={className}
            src={url}
            alt={altTag}
            loading="lazy"
            fit={fit}
            isLoading={isLoading}
            onLoad={() => setIsLoading(false)}
          />
          {/* <ImageElement src={imgSrc} alt={altTag} /> */}
        </SquareClippedFrame>
      )}
      {aspectRatio === '1/1' && imgSrc && hasFrame === 'Bottom Top Clip' && (
        <SquareClippedFrame>
          <GatsbyImage image={imgSrc} alt={altTag} />
          {/* <ImageElement src={imgSrc} alt={altTag} /> */}
        </SquareClippedFrame>
      )}
      {aspectRatio === '1/1' && hasFrame === 'Left Clipped' && (
        <SquareLeftClippedFrame>
          <GatsbyImage image={imgSrc} alt={altTag} />
          {/* <ImageElement src={imgSrc} alt={altTag} /> */}
        </SquareLeftClippedFrame>
      )}
      {aspectRatio === '4/3' && hasFrame === 'No Frame' && (
        <ImageWrapperRectangle>
          <GatsbyImage image={imgSrc} alt={altTag} />
          {/* <ImageElement src={imgSrc} alt={altTag} /> */}
        </ImageWrapperRectangle>
      )}
      {aspectRatio === '4/3' && hasFrame === 'Bottom Top Clip' && (
        <RectangleClippedFrame>
          <GatsbyImage image={imgSrc} alt={altTag} />
          {/* <ImageElement src={imgSrc} alt={altTag} /> */}
        </RectangleClippedFrame>
      )}
      {aspectRatio === '4/3' && hasFrame === 'Left Clipped' && (
        <RectangleLeftClippedFrame>
          <GatsbyImage image={imgSrc} alt={altTag} />
          {/* <ImageElement src={imgSrc} alt={altTag} /> */}
        </RectangleLeftClippedFrame>
      )}
      {aspectRatio === '4/3' && hasFrame === 'Right Clipped' && (
        <RectangleRightClippedFrame>
          <GatsbyImage image={imgSrc} alt={altTag} />
          {/* <ImageElement src={imgSrc} alt={altTag} /> */}
        </RectangleRightClippedFrame>
      )}
      {aspectRatio === '16/9' && hasFrame === 'Right Clipped' && (
        <RectangleRightClippedFrame16x9>
          <GatsbyImage image={imgSrc} alt={altTag} />
          {/* <ImageElement src={imgSrc} alt={altTag} /> */}
        </RectangleRightClippedFrame16x9>
      )}
      {aspectRatio === '1/1' && hasFrame === 'Right Clipped' && (
        <RectangleRightClippedFrame1x1>
          <GatsbyImage image={imgSrc} alt={altTag} />
          {/* <ImageElement src={imgSrc} alt={altTag} /> */}
        </RectangleRightClippedFrame1x1>
      )}
      {aspectRatio === '16/9' && hasFrame === 'No Frame' && (
        <ImageWrapperWide>
          <GatsbyImage image={imgSrc} alt={altTag} />
          {/* <ImageElement src={imgSrc} alt={altTag} /> */}
        </ImageWrapperWide>
      )}
      {aspectRatio === '16/9' && hasFrame === 'Left Clip' && imgSrc && !url && (
        <WideClippedFrame className={cutSize && 'cut-size-lg'}>
          <GatsbyImage image={imgSrc} alt={altTag} />
          {/* <ImageElement src={imgSrc} alt={altTag} /> */}
        </WideClippedFrame>
      )}
      {aspectRatio === '16/9' && hasFrame === 'Left Clip' && url && !imgSrc && (
        <WideClippedFrame className={cutSize && 'cut-size-lg'}>
          <ImageElement
            src={url}
            alt={altTag}
            loading="lazy"
            isLoading={isLoading}
            onLoad={() => setIsLoading(false)}
          />
        </WideClippedFrame>
      )}
      {aspectRatio === 'None' && hasFrame === 'No Frame' && (
        <>
          <GatsbyImage
            image={imgSrc}
            alt={altTag}
            loading={loading || 'lazy'}
            objectFit={fit}
            title={title}
          />
          {/* <ImageElement src={imgSrc} alt={altTag} /> */}
        </>
      )}
      {aspectRatio === 'None' && hasFrame === 'Left Clipped' && (
        <LeftClippedNoAspect>
          <GatsbyImage image={imgSrc} alt={altTag} />
          {/* <ImageElement src={imgSrc} alt={altTag} /> */}
        </LeftClippedNoAspect>
      )}
      {aspectRatio === '16/9' && hasFrame === 'Vehicle' && (
        <WideClippedFrame>
          <GatsbyImage image={imgSrc} alt={altTag} />
        </WideClippedFrame>
      )}
    </>
  )
}

Image.propTypes = {
  imgSrc: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.object.isRequired]),
  altTag: PropTypes.string,
  aspectRatio: PropTypes.string.isRequired,
  hasFrame: PropTypes.string.isRequired,
}
